import React from "react";
import { Route, Routes } from "react-router-dom";
import IndexPayrollConfigurations from "./settings/configurations/IndexPayrollConfigurations";
import IndexTaxStructure from "./settings/taxStructures/IndexTaxStructure";
import IndexSaleSalaryRevisions from "./salaryRevisions/IndexSalaryRevisions";
import IndexTaxAdjustments from "./openingBalances/IndexTaxAdjustments";
import IndexPayrolls from "./payrolls/IndexPayrolls";
import PayrollFormPage from "./payrolls/PayrollFormPage";
import IndexFormula from "./settings/formula/IndexForumula";
import IndexRule from "./settings/rule/IndexRule";
import IndexPayitem from "./settings/payitem/IndexPayitem";
import IndexLeaveEncashment from "./leaveEncashments/IndexLeaveEncashment";
import IndexMyPayslip from "./myPayslips/IndexMyPayslip";
import IndexVouchers from "./vouchers/IndexVouchers";
import IndexCompanyPayslip from "./companyPayslips/IndexCompanyPayslip";
import IndexSalarySheets from "./salarySheet/IndexSalarySheets";
import IndexFinalSettlement from "./finalSettlements/IndexFinalSettlement";
import IndexDailyWagePayrolls from "./dailyWagesPayroll/IndexDailyWagePayrolls";
import IndexCustomPayitem from "./settings/customPayitems/IndexCustomPayitem";
import IndexGratuity from "./settings/gratuity/IndexGratuity";
import IndexIncentives from "./incentive/components/IndexIncentives";
import { useSelector } from "react-redux";
import { guardElement } from "@comps/components";

const PayrollManagementModules = () => {

  const authUser = useSelector((state) => state.auth.authUser);
  return (
    <Routes>
      <Route path="settings/configurations" element={ guardElement(<IndexPayrollConfigurations modkey="payrollConfigurations" />, "payrollConfigurations") } />
      <Route path="settings/tax-structures" element={ guardElement(<IndexTaxStructure modkey="taxStructures" />, "taxStructures") } />
      <Route path="sale-incentive" element={ guardElement(<IndexIncentives modkey="saleIncentive" />, "saleIncentive") } />
      <Route path="leave-encashments" element={ guardElement(<IndexLeaveEncashment modkey="leaveEncashments" />, "leaveEncashments") } />
      <Route path="settings/formula" element={ guardElement(<IndexFormula modkey="formula" />, "formula") } />
      <Route path="settings/rule" element={ guardElement(<IndexRule modkey="payrollRule" />, "payrollRule") } />
      <Route path="settings/payitem" element={ guardElement(<IndexPayitem modkey="payitem" />, "payitem") } />
      <Route path="settings/gratuity" element={ guardElement(<IndexGratuity modkey="gratuity" />, "gratuity") } />
      <Route path="salary-revisions" element={ guardElement(<IndexSaleSalaryRevisions modkey="salaryRevisions" />, "salaryRevisions") } />
      <Route path="opening-balances" element={ guardElement(<IndexTaxAdjustments modkey="taxAdjustment" />, "taxAdjustment") } />
      <Route path="payrolls" element={ guardElement(<IndexPayrolls modkey="payrolls" />, "payrolls") } />
      <Route path="payrolls/create" element={ guardElement(<PayrollFormPage mode="create" modkey="payrolls" />, "payrolls", "create") } />
      <Route path="payrolls/edit/:id" element={ guardElement(<PayrollFormPage mode="edit" modkey="payrolls" />, "payrolls", "update") } />
      <Route path="payrolls/view/:id" element={ guardElement(<PayrollFormPage mode="view" modkey="payrolls" />, "payrolls") } />
      <Route path="my-payslips" element={ guardElement(<IndexMyPayslip modkey="myPayslips" employment_id={ authUser.employment_id } />, "myPayslips") } />
      <Route path="company-payslips" element={ guardElement(<IndexCompanyPayslip modkey="companyPayslips" />, "companyPayslips") } />
      <Route path="vouchers" element={ guardElement(<IndexVouchers modkey="vouchers" />, "vouchers") } />
      <Route path="salary-sheet" element={ guardElement(<IndexSalarySheets modkey="salarySheet" />, "salarySheet") } />
      <Route path="final-settlements" element={ guardElement(<IndexFinalSettlement modkey="finalSettlements" />, "finalSettlements") } />
      <Route path="daily-wage-payroll/index" element={ guardElement(<IndexDailyWagePayrolls modkey="dailyWagePayroll" />, "dailyWagePayroll") } />
      <Route path="custom-payitem/item/:name/:id" element={ guardElement(<IndexCustomPayitem modkey="customPayitem" />, "customPayitem") } />
    </Routes >
  );
}

export default PayrollManagementModules;
